import { ApiConstants } from "../../constants/ApiConstants";
import { SALES_GROWTH_COUNT, SALES_GROWTH_GET } from "../Constants/SalesGrowthConstants";
import { createPostDataAction } from "./CommonAction";



export const SalesGrowthGetAction = (payload: any) => createPostDataAction(SALES_GROWTH_GET, ApiConstants?.SalesGrowthGet, payload, false);
export const SalesGrowthCountAction = (payload: any) => createPostDataAction(SALES_GROWTH_COUNT, ApiConstants?.SalesGrowthCount, payload, false);
